import styled from '@emotion/styled';

export const Wrapper = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.error};
  margin: -25px 0 25px;
  font-style: italic;
`;
